import { ACTION_IDS } from '@edulastic/common'

export const ACTION_HUB_JOYRIDE_DASHBOARD_PATH = '/author/dashboard'

export const getActionHubElementId = (id) => `action-hub-${id}`

export const ACTION_HUB_JOYRIDE_IDS = {
  FAB: getActionHubElementId('fab'),
  MENU: getActionHubElementId('menu'),
  PEARY: getActionHubElementId(ACTION_IDS.PEARY),
  FEEDBACK: getActionHubElementId(ACTION_IDS.FEEDBACK),
  ARTICLES: getActionHubElementId(ACTION_IDS.ARTICLES),
  SUPPORT: getActionHubElementId(ACTION_IDS.SUPPORT),
}

export const getActionHubJoyrideTarget = (id) => `[data-joyride-id="${id}"]`

export const ACTION_HUB_JOYRIDE_TARGETS = {
  FAB: getActionHubJoyrideTarget(ACTION_HUB_JOYRIDE_IDS.FAB),
  MENU: getActionHubJoyrideTarget(ACTION_HUB_JOYRIDE_IDS.MENU),
  PEARY: getActionHubJoyrideTarget(ACTION_HUB_JOYRIDE_IDS.PEARY),
  FEEDBACK: getActionHubJoyrideTarget(ACTION_HUB_JOYRIDE_IDS.FEEDBACK),
  ARTICLES: getActionHubJoyrideTarget(ACTION_HUB_JOYRIDE_IDS.ARTICLES),
  SUPPORT: getActionHubJoyrideTarget(ACTION_HUB_JOYRIDE_IDS.SUPPORT),
}

export const ACTION_HUB_JOYRIDE_SPOTLIGHT_PADDING = {
  FAB: 8,
  MENU: 6,
  MENU_ITEM: 4,
}

export const ACTION_HUB_JOYRIDE_CTA_MAP = {
  [ACTION_HUB_JOYRIDE_TARGETS.FAB]: 'Intro',
  [ACTION_HUB_JOYRIDE_TARGETS.MENU]: 'OpenActionHub',
  [ACTION_HUB_JOYRIDE_TARGETS.PEARY]: 'OpenPeary',
  [ACTION_HUB_JOYRIDE_TARGETS.FEEDBACK]: 'OpenFeedback',
  [ACTION_HUB_JOYRIDE_TARGETS.ARTICLES]: 'OpenArticles',
  [ACTION_HUB_JOYRIDE_TARGETS.SUPPORT]: 'OpenSupport',
}
